import React from 'react';

interface YouTubeEmbedProps {
  videoId: string;
  title?: string;
  className?: string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ 
  videoId, 
  title = "YouTube video",
  className = "aspect-video" 
}) => {
  // Validate video ID format (YouTube IDs are typically 11 characters)
  if (!videoId || typeof videoId !== 'string' || videoId.length === 0) {
    return (
      <div className={`${className} w-full flex items-center justify-center bg-dark-navy rounded-lg text-medium-gray`}>
        Video ID not provided
      </div>
    );
  }

  // Extract actual video ID if a full URL was passed
  let cleanVideoId = videoId;
  if (videoId.includes('youtube.com') || videoId.includes('youtu.be')) {
    // Handle various YouTube URL formats
    if (videoId.includes('v=')) {
      // Format: https://www.youtube.com/watch?v=VIDEO_ID
      cleanVideoId = videoId.split('v=')[1].split('&')[0];
    } else if (videoId.includes('youtu.be/')) {
      // Format: https://youtu.be/VIDEO_ID
      cleanVideoId = videoId.split('youtu.be/')[1].split('?')[0];
    } else if (videoId.includes('/embed/')) {
      // Format: https://www.youtube.com/embed/VIDEO_ID
      cleanVideoId = videoId.split('/embed/')[1].split('?')[0];
    }
    
    // Clean up any extra parameters
    if (cleanVideoId.includes('?')) {
      cleanVideoId = cleanVideoId.split('?')[0];
    }
  }

  // Validate the extracted video ID
  if (cleanVideoId.length !== 11) {
    return (
      <div className={`${className} w-full flex items-center justify-center bg-dark-navy rounded-lg text-medium-gray`}>
        Invalid YouTube URL
      </div>
    );
  }

  const embedUrl = `https://www.youtube.com/embed/${cleanVideoId}`;

  return (
    <div className={className}>
      <iframe
        src={embedUrl}
        title={title}
        className="w-full h-full rounded-lg"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default YouTubeEmbed;